// 매체소개서, 집행사례
// export const iw = '//cdn.interworksmedia.co.kr/interview/interworksMedia.pdf'
// export const iwCase = '//cdn.interworksmedia.co.kr/interview/interworksMedia_case.pdf'

export const iw = '//cdn.interworksmedia.co.kr/interview/interworksMedia20220616.pdf'
export const iwCase = '//cdn.interworksmedia.co.kr/interview/interworksMedia_Case20220616.pdf'
export const iwCase2 = '//cdn.interworksmedia.co.kr/interview/interworksmedia_case20220616.pdf'

// export const ip = '//cdn.interworksmedia.co.kr/interview/interPlay.pdf'
// export const ipCase = '//cdn.interworksmedia.co.kr/interview/interPlay_case.pdf'

// sample video url
export const mVideoUrl = '//cdn.interworksmedia.co.kr/sample/interplay_mobile.mp4'
export const pcVideoUrl = '//cdn.interworksmedia.co.kr/sample/interplay_pc.mp4'

// sample page url
export const ipUrl = 'http://cdn.interworksmedia.co.kr/sample/interplay/fullScreen_interplay.html'
// export const ipUrl = 'http://docs.interworksmedia.co.kr/test/interplay.html'
export const mipUrl =
    '//cdn.interworksmedia.co.kr/sample/minterplay/interplay_mobile.html'
export const isUrl = 'http://docs.interworksmedia.co.kr/test/interscroll.html'
// export const ipPlusUrl = 'http://tv.interworksmedia.co.kr/sample/interplus.html'
export const ipPlusUrl = 'http://docs.interworksmedia.co.kr/test/interplay_plus_bip.html'
export const nbaUrl = 'http://docs.interworksmedia.co.kr/test/internative.html'
export const nhbaUrl = 'http://docs.interworksmedia.co.kr/test/internative_mobile.html'

export const ipSkinPc = ' http://cdn.interworksmedia.co.kr/sample/interplay/brandplus_interplay.html'
// export const ipSkinPc = 'https://cdn.interworksmedia.co.kr/sample/interplay/02/pc/interplay_skin2.html'
export const ohipBrandUp = 'https://cdn.interworksmedia.co.kr/sample/interplay/12/mo/interplay.html?no=SHIP'

export const ipPerformancePc = 'https://cdn.interworksmedia.co.kr/sample/interplay/performance_pc_interplay.html'
export const ipPerformanceMo = 'https://cdn.interworksmedia.co.kr/sample/interplay/perfomance_mobileinterplay.html'

export const ipShortsPc = 'http://cdn.interworksmedia.co.kr/sample/interplay/c06_pc_interplay.html'
export const ipShortsMo = 'http://cdn.interworksmedia.co.kr/sample/interplay/c06_mobile_interplay.html'
export const ipSavePc = 'http://cdn.interworksmedia.co.kr/sample/interplay/interplaySave_Pc.html'
export const ipSaveMo = 'http://cdn.interworksmedia.co.kr/sample/interplay/interplaySave_Mo.html'



// WEBPACK FOOTER //
// ./src/assets/links.js